import { VImg } from 'vuetify/lib/components/VImg';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,{attrs:{"value":_vm.loading,"absolute":"","color":"white","opacity":0.9}},[_c('p',{staticClass:"text--disabled text-end ma-0 pa-0 code-metamask"},[_vm._v(_vm._s(_vm.$t('tokens.titles.waitingFor')))]),_c(VImg,{attrs:{"src":require('../../../assets/img/metamask-logo.svg'),"contain":""}}),_c(VProgressLinear,{staticClass:"mt-1",attrs:{"indeterminate":"","color":"#f5841f"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }